import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';

/**
 * Indicador del flujo de creación, grande y arriba de cada paso:
 * 1 Escoge tus productos → 2 Escoge el diseño → 3 Genera el post.
 */
export function PasosPost({ paso }: { paso: 1 | 2 | 3 }) {
  const { t } = useTranslation();
  const pasos = [t('plantillas.paso1'), t('plantillas.paso2'), t('plantillas.paso3')];

  return (
    <ol className="flex flex-wrap items-center justify-center gap-2 sm:gap-3">
      {pasos.map((etiqueta, i) => {
        const n = (i + 1) as 1 | 2 | 3;
        const activo = n === paso;
        const hecho = n < paso;
        return (
          <li key={etiqueta} className="flex items-center gap-2 sm:gap-3">
            <span
              className={`flex min-h-11 items-center gap-2.5 rounded-full py-2 pl-2 pr-4 text-[15px] ${
                activo
                  ? 'bg-negro font-semibold text-white shadow-[var(--sombra-alta)]'
                  : hecho
                    ? 'bg-superficie font-medium text-principal shadow-[var(--sombra)]'
                    : 'bg-superficie2 font-medium text-suave'
              }`}
            >
              <span
                className={`flex h-8 w-8 flex-none items-center justify-center rounded-full text-[15px] font-semibold ${
                  activo ? 'text-negro' : hecho ? '' : 'bg-superficie text-suave'
                }`}
                style={
                  activo || hecho
                    ? { backgroundColor: 'var(--color-acento-var)', color: 'var(--color-acento-texto)' }
                    : undefined
                }
              >
                {hecho ? <Check size={16} /> : n}
              </span>
              {etiqueta}
            </span>
            {n < 3 ? <span className="h-px w-4 bg-negro/15 sm:w-8" /> : null}
          </li>
        );
      })}
    </ol>
  );
}
